import { Link } from "react-router-dom";
import { CheckCircle2, MailWarning } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "../components/ui/button";

export const SuccessStep = ({ booking, onNewBooking }) => {
  const { t } = useLanguage();

  return (
    <div data-testid="booking-success-step" className="max-w-md mx-auto text-center py-10">
      <CheckCircle2 size={56} className="text-gold mx-auto mb-6" />
      <h2 className="font-serif text-2xl sm:text-3xl text-white mb-3">{t("booking.success.title")}</h2>
      <p className="text-white/70 mb-6 leading-relaxed">{t("booking.success.message")}</p>
      {booking?.appointment_number && (
        <>
          <p data-testid="booking-reference" className="text-white/40 text-xs mb-2">
            {t("booking.success.reference")}: <span className="text-gold font-semibold">#{booking.appointment_number}</span>
          </p>
          <p className="text-white/40 text-xs mb-6">{t("booking.success.keepNumber")}</p>
        </>
      )}
      <div data-testid="booking-success-spam-tip" className="flex items-start gap-2.5 text-left bg-white/[0.04] border border-white/10 rounded-md px-4 py-3 mb-8">
        <MailWarning size={16} className="text-gold shrink-0 mt-0.5" />
        <p className="text-white/50 text-xs leading-relaxed">{t("booking.success.spamTip")}</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/">
          <Button data-testid="booking-back-home-button" variant="outline" className="bg-transparent border border-white/20 text-white hover:border-gold hover:text-gold rounded-none px-8">
            {t("booking.success.backHome")}
          </Button>
        </Link>
        <Button data-testid="booking-new-booking-button" onClick={onNewBooking} className="bg-gold text-white hover:bg-gold-hover rounded-none px-8">
          {t("booking.success.newBooking")}
        </Button>
      </div>
      <Link to="/mijn-afspraak" data-testid="booking-success-manage-link" className="block text-white/40 text-xs mt-6 hover:text-gold underline underline-offset-4">
        {t("booking.success.manageLink")}
      </Link>
    </div>
  );
};
